// extracted by mini-css-extract-plugin
export default {"wrap":"GG-z","subtitle":"HG-z","contentWrap":"IG-z","imgWrap":"JG-z","heading":"KG-z","copy":"LG-z"};